import script from "./CopyClipboardButton.vue?vue&type=script&setup=true&lang=js"
export * from "./CopyClipboardButton.vue?vue&type=script&setup=true&lang=js"

import "./CopyClipboardButton.vue?vue&type=style&index=0&id=b8d4ec54&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b8d4ec54"]])

export default __exports__